var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM12 18C11.34 18 10.8 17.46 10.8 16.8V12C10.8 11.34 11.34 10.8 12 10.8C12.66 10.8 13.2 11.34 13.2 12V16.8C13.2 17.46 12.66 18 12 18ZM13.2 8.4H10.8V6H13.2V8.4Z",
    fill: "#B1A5F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationIcon);
export default __webpack_public_path__ + "static/media/exclamationIcon.c3cb455f783e8aadb1cd4133c07ea4aa.svg";
export { ForwardRef as ReactComponent };